import { useEffect } from 'react';

/**
 * @param {array} options - useEffect dependencies
 * @param {object} currentTab - from useRef()
 */
export default function useTabCentered(options=[], currentTab) {
  useEffect(() => {
    const target = currentTab.current;
    if (target) {
      target.parentNode.scrollLeft =
        target.offsetLeft - target.parentNode.offsetLeft - (target.parentNode.clientWidth - target.clientWidth) / 2;
    }
  }, options);
}